
import Vue from "vue";
import AppProductEditRow from "./SaleEditRow.vue";
import AppProductsTable from "./ProductsTable.vue";
import { SaleEditState } from "@/utils/sale-edit/sale-edit-state";
import { CustomTranslation } from "@/utils/custom-translation";
import { Sale, SaleRow } from "@/models/base";
import {DossierConfigService} from "@/services";

export default Vue.extend({
	props: {
		state: {
			type: Object as ()=>SaleEditState,
			required: true
		},
	},
	computed: {
		sale():Sale{
			return this.state.sale;
		}
	},
	methods: {
		scrollBottom() {
			var container = this.$el.querySelector("#products-table > tbody");
			if (container)
				container.scrollTop = (container.scrollHeight + 29);
		},
		// eslint-disable-next-line max-lines-per-function
		addSubtotal() {
			let n = 0;
			let b = 0;
			let c = DossierConfigService.getSaleConfigs().AddNotToPrintToTotal;
			let index = this.sale.Rows.indexOf(this.state.selectedRow);
			if(index>=0){
				for (let i = index; i >= 0; i--) {
					if ((this.sale.Rows[i] as SaleRow).SaleRowConfig.SubTotal) {
						break;
					}
					if(this.sale.Rows[i].getRowConfig().Hidden && !c){
						continue;
					}
					n += (this.sale.Rows[i] as SaleRow).TotalPriceExcVat;
					b += (this.sale.Rows[i] as SaleRow).TotalPriceIncVat;
				}
			}else{
				for (let i = this.sale.Rows.length - 1; i >= 0; i--) {
					if ((this.sale.Rows[i] as SaleRow).SaleRowConfig.SubTotal) {
						break;
					}
					n += (this.sale.Rows[i] as SaleRow).TotalPriceExcVat;
					b += (this.sale.Rows[i] as SaleRow).TotalPriceIncVat;
				}
			}

			let saleRow = new SaleRow();
			if (this.state.config !== null) {
				let t = new CustomTranslation(this.state.config.SubTotal);
				let v = t.getTranslation(this.state.sale.Lng);
				v = v.replace("{excl}",n.toFixed(2));
				v = v.replace("{incl}",b.toFixed(2));
				saleRow.ProductDescription = v;
			}
			saleRow.SaleRowConfig.SubTotal = true;
			saleRow.DisplayOrder = this.sale.Rows.length + 1;
			if(index>=0){
				this.sale.Rows.splice(index+1, 0, saleRow);
			}else {
				this.sale.Rows.push(saleRow);
			}
		},
	},
	components: {
		AppProductEditRow,
		AppProductsTable
	}
});
